import React from 'react';
import {serviceRetailerDropdown} from "../../../utils/retailerDisplayFormatter";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import EditableReactTableV2 from "../../Components/ReactTable/EditableReactTableV2";
import {INDEX_FIELD, RETAILER_ID_NAME_COLUMN} from "../../Components/ReactTable/common_custom_columns";
import {EditFormDropdownInputField, EditFormNumberInputField} from "../../Components/ReactTable/EditRecordForm";
import CollapsableContent from "../../Components/CollapsableContent";
import _ from "lodash";

function ReceiptLagService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/receiptLagHistory`
    const endpointUrlForPost = `${process.env.REACT_APP_EDP_API_BASE_URL}/receiptLag/`
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl, endpointUrlForPost});


    const columns = [
        RETAILER_ID_NAME_COLUMN,
        {header: "Receipt Lag", accessorKey: "receiptLag", size: 50},
        {header: "Roll Up Day Of Week", accessorKey: "rollUpDayOfWeek"},
        {
            header: "History",
            cell: ({row}) => {
                if (_.isEmpty(row.original.history)) {
                    return <div>No Ingestion History</div>;
                }
                const expandedContent = <ul className={'receipt-lag-history-list'}
                                            title={"Sales End Date, Date of Ingestion, Filename"}>
                    {row.original.history.map(
                        (history_log) => <li>
                            {history_log.salesEndDate}, <b>{history_log.dateOfIngestion}</b>, {history_log.fileName}

                        </li>
                    )}
                </ul>

                return <CollapsableContent className={'receipt-lag-history-collapsable-content'} expandedContent={expandedContent} collapsedContent={"show history"}/>;
            },
            size: 300
        }
    ];

    const removeNonReceiptLagFields = newOrUpdatedRow => {
        const receiptLagFields = ["index", "retailerId", "receiptLag"];
        Object.keys(newOrUpdatedRow).forEach(key => {
            if (!receiptLagFields.includes(key)) delete newOrUpdatedRow[key];
        });
        return newOrUpdatedRow;
    };

    const onRowEditConfirmedWrapper = async newOrUpdatedRow => {
        const sanitizedRow = removeNonReceiptLagFields(newOrUpdatedRow);
        await onRowEditConfirmed(sanitizedRow);
    };

    const onRowDeleteConfirmedWrapper = async (row) => {
        const sanitizedRow = removeNonReceiptLagFields(row);
        await onRowDeleteConfirmed(sanitizedRow);
    }

    return (<Page name={"Receipt Lag"} breadCrumbs={<Breadcrumbs
        items={[{label: "Configurations"}, {label: "Retailer"}, {label: "Receipt Lag"}]}/>}>
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={columns}
                initialState={{pagination: {pageSize: 25}, sorting: [{id: "retailerIdName", desc: false}]}}
                actionButtonsProps={{showAddButton: false}}
                editTable={[
                    INDEX_FIELD,
                    {id: 'retailerId', Component: args => <EditFormDropdownInputField {...args} options={serviceRetailerDropdown().data} label="Retailer Id" disabled={true} isRequired={true}/>},
                    {id: 'receiptLag', Component: args => <EditFormNumberInputField {...args} isRequired/>}
                ]}
                onRowEditConfirmed={onRowEditConfirmedWrapper}
                onRowDeleteConfirmed={onRowDeleteConfirmedWrapper}
            />
        </LoadingWrapper>
    </Page>);
}

export default ReceiptLagService;
